import React, { useContext } from "react";
import PostArticle from "../Forms/PostArticle";
import "./../../App.css";

import { UserContext } from "./../../context/UserContext";
import { useNavigate } from "react-router-dom";

const Create = () => {
  const { state } = useContext(UserContext);
  const navigate = useNavigate();
  return (
    <>
      <div className="blog-d">
        <h2 className="text-center blog-header-rm text-uppercase">
          Write Blog
        </h2>

        {state ? (
          <form method="POST" encType="multipart/form-data">
            <PostArticle />
          </form>
        ) : (
          <>
            <div className="mt-5">
              <div className="row justify-content-center">
                <div className="col-md-8">
                  <div className="alert alert-danger text-center" role="alert">
                    <h1 className="text-medium">Access Denied</h1>
                    <p>
                      Oops! It seems you need to log in to access this page.
                    </p>
                    <p>
                      Please log in or return to the home page for more options.
                    </p>
                    <button
                      className="btn btn-primary btn-lg mt-3"
                      onClick={() => navigate("/login", { replace: true })}
                    >
                      Log In
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Create;
